export const departmentList = [
  { id: "cs", label: "客服部", icon: "ri-customer-service-2-line" },
  { id: "sales", label: "銷售部", icon: "ri-line-chart-line" },
  { id: "accounting", label: "會計部 / 財務", icon: "ri-calculator-line" },
  { id: "logistics", label: "物流部", icon: "ri-truck-line" },
  { id: "it", label: "資訊部 / 系統", icon: "ri-code-s-slash-line" },
];

export interface MockEmployee {
  id: string;
  employee_code: string;
  name: string;
  email: string;
  department: string;
  position: string;
  role_level: string;
  status: string;
}

export const mockEmployees: MockEmployee[] = [
  { id: "e-001", employee_code: "A002", name: "Roxane", email: "roxanedeshawn925@gmail.com", department: "客服部", position: "試用期員工", role_level: "trial", status: "active" },
  { id: "e-002", employee_code: "A003", name: "羅曼莎", email: "lisanow481@gmail.com", department: "客服部", position: "試用期員工", role_level: "trial", status: "active" },
  { id: "e-003", employee_code: "E001", name: "于家瑜", email: "roxanedeshawn925@gmail.com", department: "資訊部", position: "資料分析師", role_level: "employee", status: "active" },
  { id: "e-004", employee_code: "E002", name: "葉語瑄", email: "tranghmai4@gmail.com", department: "銷售部", position: "業務", role_level: "employee", status: "active" },
  { id: "e-005", employee_code: "E003", name: "蕭品安", email: "roxanedeshawn925@gmail.com", department: "物流部", position: "物流主管", role_level: "manager", status: "active" },
  { id: "e-006", employee_code: "E004", name: "王明哲", email: "tranghmai4@gmail.com", department: "銷售部", position: "行銷主管", role_level: "manager", status: "active" },
  { id: "e-007", employee_code: "E005", name: "林佩芸", email: "tranghmai4@gmail.com", department: "會計部", position: "會計專員", role_level: "employee", status: "active" },
  { id: "e-008", employee_code: "E006", name: "楊俊翔", email: "roxanedeshawn925@gmail.com", department: "財務部", position: "財務專員", role_level: "employee", status: "active" },
  { id: "e-009", employee_code: "E007", name: "吳建宏", email: "tranghmai4@gmail.com", department: "財務部", position: "會計", role_level: "employee", status: "active" },
  { id: "e-010", employee_code: "E008", name: "廖雅惠", email: "tranghmai4@gmail.com", department: "財務部", position: "財務專員", role_level: "employee", status: "active" },
];

export interface MockMessage {
  id: string;
  sender_employee_id: string;
  recipient_employee_id: string | null;
  department: string | null;
  content: string;
  is_read: boolean;
  created_at: string;
  sender_name?: string;
  sender_code?: string;
}

export const mockMessages: MockMessage[] = [
  // Department chat messages (recipient_employee_id = null)
  {
    id: "m-001",
    sender_employee_id: "e-003",
    recipient_employee_id: null,
    department: "客服部",
    content: "客服部早上好，銷售部這邊有個客戶反映紅酒瓶塞有問題，請幫忙處理一下",
    is_read: false,
    created_at: "2026-07-03T09:00:00Z",
    sender_name: "于家瑜",
    sender_code: "E001",
  },
  {
    id: "m-002",
    sender_employee_id: "e-001",
    recipient_employee_id: null,
    department: "客服部",
    content: "收到，請提供訂單編號我們馬上查",
    is_read: false,
    created_at: "2026-07-03T09:05:00Z",
    sender_name: "Roxane",
    sender_code: "A002",
  },
  {
    id: "m-003",
    sender_employee_id: "e-004",
    recipient_employee_id: null,
    department: "銷售部",
    content: "今天有個大客戶要來看樣品，誰可以幫忙準備？",
    is_read: true,
    created_at: "2026-07-03T08:30:00Z",
    sender_name: "葉語瑄",
    sender_code: "E002",
  },
  // Private messages (manager center style, with department as identity)
  {
    id: "m-004",
    sender_employee_id: "e-005",
    recipient_employee_id: "e-001",
    department: "物流部",
    content: "Roxane，你的貨已經安排出倉了，預計明天到港",
    is_read: true,
    created_at: "2026-07-03T10:15:00Z",
    sender_name: "蕭品安",
    sender_code: "E003",
  },
  {
    id: "m-005",
    sender_employee_id: "e-001",
    recipient_employee_id: "e-005",
    department: null,
    content: "收到，感謝通知！",
    is_read: true,
    created_at: "2026-07-03T10:20:00Z",
    sender_name: "Roxane",
    sender_code: "A002",
  },
];